import { configureSlices } from "utils/store/configureSlices";

import brokerDispatchResponseSlice from "./BrokerDispatchResponseSlice";

export const { useSlices: usebrokerDispatchResponseStore, useSliceSelector: usebrokerDispatchResponseSelector } =
  configureSlices({
    brokerDispatchResponseSlice,
  });
